<div class="flex items-center justify-center min-h-screen bg-gray-50 px-4">
  <div class="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center border border-gray-100">
    <div class="mx-auto flex items-center justify-center h-20 w-20 rounded-full bg-red-50 mb-6">
      <svg class="h-10 w-10 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
      </svg>
    </div>

    <h2 class="text-2xl font-bold text-gray-900 mb-3 tracking-tight">
      Menu Unavailable
    </h2>
    <p class="text-gray-500 mb-8 leading-relaxed">
      This digital menu is not currently active. Please ask a staff member for a physical menu or assistance.
    </p>

  </div>
</div>